import moment from 'moment';
import get from 'lodash/get';
import { numberUnmask, floatUnmask } from 'utils/masks';

const applePaySchema = {
  applyDate: [{
    rule: 'required',
    isValid: (input, err, opt, formData) => {
      if (!input) {
        return 'The input field is required';
      }

      if (numberUnmask(input).length < 8) {
        return 'Payment date is not valid';
      }

      if (!moment(input, 'MM/DD/YYYY').isValid()) {
        return 'Payment date is not valid';
      }

      if ((moment(input, 'MM/DD/YYYY').isBefore(moment().subtract(1, 'day')) || moment(input, 'MM/DD/YYYY').isAfter(moment().add(45 - Number(formData.daysPastDue), 'days'))) && Number(formData.daysPastDue) <= 45) {
        return `Payments can only be scheduled between ${moment().format('MM/DD/YYYY')} and ${moment().add(45 - Number(formData.daysPastDue), 'days').format('MM/DD/YYYY')}`;
      }

      return true;
    },
  }],
  selectedAmountOption: [{
    isValid: (input, err, opt, formData) => {
      const selectedAmountOption = get(formData, 'selectedAmountOption');
      const quickpayData = get(formData, 'rawData') || {};

      if (!input) {
        return 'The input field is required';
      }

      if (selectedAmountOption === '2') {
        return true;
      }

      if (
        (selectedAmountOption === '0' && quickpayData.totalDue < 1)
        || (selectedAmountOption === '1' && (quickpayData.amountPastDue + quickpayData.dueFees) < 1)
      ) {
        return 'Payment amount cannot be less than $1.00';
      }

      return true;
    },
  }],
  customPaymentAmount: [{
    isValid: (input, err, opt, formData) => {
      const selectedAmountOption = get(formData, 'selectedAmountOption');

      if (selectedAmountOption !== '2') {
        return true;
      }

      if (!input) {
        return 'The input field is required';
      }

      return Number(floatUnmask(input)) < 1 ? 'Payment amount cannot be less than $1.00' : true;
    },
  }],
};

export default applePaySchema;
